// controls/AddLocationCard.tsx
import { Card, Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const AddLocationCard = () => {
  const navigate = useNavigate();

  return (
    <Card
      onClick={() => navigate("/location/add")}
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 3,
        cursor: "pointer",
        backgroundColor: "#f8fafc",
        border: "1.5px dashed #94a3b8",
        boxShadow: 0,
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#eff6ff",
          borderColor: "#2563eb",
          transform: "translateY(-3px)",
          boxShadow: "0 12px 28px rgba(15, 23, 42, 0.08)",
        },
      }}
    >
      <Box textAlign="center">
        <Box
          sx={{
            width: 48,
            height: 48,
            mx: "auto",
            mb: 1.5,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            bgcolor: "#dbeafe",
            color: "#2563eb",
          }}
        >
          <AddIcon sx={{ fontSize: 26 }} />
        </Box>
        <Typography variant="h6" color="text.primary" sx={{ fontWeight: 700 }}>
          Add Location
        </Typography>
      </Box>
    </Card>
  );
};

export default AddLocationCard;
